import React from "react";
import { Instagram, Facebook } from "lucide-react";
import { SOCIAL } from "../mock";

const TikTok = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.5 2h-3.2v13.3a2.9 2.9 0 1 1-2.9-2.9c.3 0 .6 0 .9.1V9.2a6.2 6.2 0 1 0 5.2 6.1V8.6a7.4 7.4 0 0 0 4.3 1.4V6.8A4.4 4.4 0 0 1 16.5 2z" />
  </svg>
);

const ICONS = { instagram: Instagram, facebook: Facebook, tiktok: TikTok };

export const SocialLinks = ({ dark = true, size = 17 }) => (
  <div className="flex gap-3" data-testid="social-links">
    {SOCIAL.map((s) => {
      const Icon = ICONS[s.id];
      return (
        <a
          key={s.id}
          href={s.url}
          target="_blank"
          rel="noreferrer"
          aria-label={`Alameda BJJ on ${s.name}`}
          data-testid={`social-${s.id}`}
          className={`h-10 w-10 rounded-full flex items-center justify-center transition-colors ${
            dark ? "bg-white/10 text-white hover:bg-br-green" : "bg-br-green/10 text-br-green hover:bg-br-green hover:text-white"
          }`}
        >
          <Icon size={size} />
        </a>
      );
    })}
  </div>
);

export default SocialLinks;
